export default {
  edit: "settings:edit",
  create: "settings:create",
  delete: "settings:delete",
  view: "settings:view",
};
